module.exports = __webpack_public_path__ + "img/fastforge.16b9fe52.svg";